import { registerPlugin } from "@capacitor/core";

export interface StartAuthSessionOptions {
  /** Idura / BankID continue URL (https). */
  url: string;
  /** Custom scheme ASWebAuthenticationSession watches for (e.g. se.bilenia.app). */
  callbackScheme?: string;
}

export interface StartAuthSessionResult {
  /** Full callback URL, e.g. se.bilenia.app://auth?nativeCode=… */
  url: string;
}

export interface BileniaBrowserPlugin {
  /** Opens http(s) URL in system Safari. Prefer startAuthSession for BankID. */
  openExternal(options: { url: string }): Promise<void>;
  /**
   * iOS ASWebAuthenticationSession — system auth sheet, returns when redirect
   * hits callbackScheme. No Safari leftover, no “Open in app?” prompt.
   */
  startAuthSession(options: StartAuthSessionOptions): Promise<StartAuthSessionResult>;
  cancelAuthSession(): Promise<void>;
}

/** Native iOS only — registered in BridgeViewController. */
export const BileniaBrowser = registerPlugin<BileniaBrowserPlugin>("BileniaBrowser");
